<template>
  <w-modal
    v-model="show"
    close-button="Anuluj"
    submit-button="Zapisz"
    title="Dodawanie przypomnienia"
    :close-on-submit="false"
    :hide-on-overlay="false"
    :hide-on-esc="false"
    @submit="save"
    @close="close"
  >
    <div class="row">
      <div class="form-group col-12">
        <w-textarea :model="$schema.body" />
      </div>

      <div class="form-group col-12">
        <w-datepicker :model="$schema.visibilityDate" />
      </div>

      <div class="form-group col-12">
        <button type="button" class="btn btn-sm btn-warning mr-1" @click="addDays(25, new Date())">
          Termin administracyjny
        </button>

        <button type="button" class="btn btn-sm btn-warning mr-1" @click="addDays(7)">
          + 7 dni
        </button>

        <button type="button" class="btn  btn-sm btn-warning mr-1" @click="addDays(14)">
          + 14 dni
        </button>

        <button type="button" class="btn  btn-sm btn-warning mr-1" @click="addDays(21)">
          + 21 dni
        </button>
      </div>
    </div>
  </w-modal>
</template>

<script>
import moment from 'moment';

import { manageMixin } from '@/mixins/manage';
import schema from '@/schemas/systemMessage.schema';

const emptyData = () => ({
  visibilityDate: moment().format('YYYY-MM-DD'),
  receiverId: null,
  entityId: '',
  entityType: '',
  name: '',
  body: 'Przypomnienie'
});

// @vuese
// Modal dodania powiadomienia
// @group Modals
export default {
  mixins: [manageMixin('systemMessage', {}, emptyData)],
  props: {
    // Typ powiązanej encji
    entityType: {
      type: String,
      required: true
    },
    // Identyfikator powiązanej encji
    entityId: {
      type: String,
      required: true
    },
    // Identyfikator profilu odbiorcy
    receiverId: {
      type: Number,
      required: true
    },
    // Nazwa powiadomienia
    name: {
      type: String,
      required: true
    }
  },
  schema,
  methods: {
    // @vuese
    // Ustawia dane formularza
    setData() {
      this.$schema.$setData({
        ...emptyData(),
        entityType: this.entityType,
        entityId: this.entityId,
        receiverId: this.receiverId,
        name: this.name
      });
      this.$schema.$reset();
    },

    // @vuese
    // Dodaje dni do daty
    addDays(days, date = this.$schema.visibilityDate.$model || new Date()) {
      this.$schema.visibilityDate.$model = moment(date)
        .add(days, 'days')
        .format('YYYY-MM-DD');
    }
  }
};
</script>
